/**
 * Editor palette: 95%-lightness sheet with a green/orange high-contrast pairing.
 * Green = committed/selected, orange = in-progress/preview/warning.
 */
export const COLORS = {
  background: 0xf2f2f2,
  gridMinor: 0xe6e6e6,
  gridMajor: 0xd4d4d4,
  axisX: 0xe8a33d,
  axisY: 0x4e9c6b,
  selection: 0x0b6b34,
  draft: 0x1d7a3f,
  preview: 0xd9660b,
  snap: 0xc2410c,
  crosshair: 0x4b5563,
  windowSelect: 0x0b6b34,
  crossingSelect: 0xd9660b,
  text: 0x1f2937,
  constraint: 0x0f766e,
} as const;
